import React, { Suspense }                 from 'react'
import Router                              from './routes'
import { SnackbarProvider }                from 'notistack'
import ThemeProvider                       from './ui/theme'
import { useCurrentPhone, useCurrentUser } from './utils/api'

export const AppContext = React.createContext({
  user: null,
});

function App () {

  const [user, setUser] = useCurrentUser()
  const [phone, setPhone] = useCurrentPhone()

  return (<Suspense fallback="loading">
    <ThemeProvider>
      <AppContext.Provider value={{ user: user, setUser: setUser, phone: phone, setPhone: setPhone }}>
        <SnackbarProvider>
          <Router/>
        </SnackbarProvider>
      </AppContext.Provider>
    </ThemeProvider>
  </Suspense>)
}

export default App
